








import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import UpdateCurrentUserForm from '@/components/users/update-current-user-form.vue';

@Component({
  components: {
    UpdateCurrentUserForm,
  },
})
export default class UpdateCurrentUser extends BaseComponent {}
